import { ObjectValues } from '@app/types/index';
import {
  AddCartLineItemErrorCodes,
  AddCartLineItemErrorCodeType,
  AddLineItemAPIError,
} from '@app/types/monolith/types';

export enum SizeGuideButtonExperience {
  Experience1 = 'Experience1',
  Experience2 = 'Experience2',
}

export const AddLineItemError = {
  ItemUnavailable: 'itemUnavailable',
  InvalidQuantity: 'invalidQuantity',
  Retryable: 'retryable',
} as const;

type AddLineItemErrorType = ObjectValues<typeof AddLineItemError>;

const AddCartLineItemErrorTypeMap: Record<
  AddCartLineItemErrorCodeType,
  AddLineItemErrorType
> = {
  [AddCartLineItemErrorCodes.InventoryItemNotAvailable]:
    AddLineItemError.ItemUnavailable,
  [AddCartLineItemErrorCodes.InvalidInventoryItemId]:
    AddLineItemError.ItemUnavailable,
  [AddCartLineItemErrorCodes.InvalidCartItemInput]:
    AddLineItemError.InvalidQuantity,
  [AddCartLineItemErrorCodes.InvalidItemQuantity]:
    AddLineItemError.InvalidQuantity,
  [AddCartLineItemErrorCodes.CartExceedsMaximumItems]:
    AddLineItemError.InvalidQuantity,
  [AddCartLineItemErrorCodes.CartItemCreateUnexpectedError]:
    AddLineItemError.Retryable,
};

export const getHighestPriorityAddItemErrorType = (
  errors: AddLineItemAPIError[]
): AddLineItemErrorType => {
  let hasInvalidQtyErr = false;
  for (const error of errors) {
    const matchedErrorType = AddCartLineItemErrorTypeMap[error.error_code];

    // itemUnavailable is the highest priority error type, there is no need to look through other errors
    if (matchedErrorType === AddLineItemError.ItemUnavailable)
      return AddLineItemError.ItemUnavailable;

    if (matchedErrorType === AddLineItemError.InvalidQuantity)
      hasInvalidQtyErr = true;
  }

  return hasInvalidQtyErr
    ? AddLineItemError.InvalidQuantity
    : AddLineItemError.Retryable;
};
